module.exports = __webpack_public_path__ + "img/audit_report.97fe4b45.svg";